<template>
    <v-btn
        v-if="shareLinkUrl"
        icon
        small
        :color="color"
        :loading="isGenerating"
        title="Generate public shareable link"
        aria-label="Generate public shareable link"
        @click.stop.prevent="generateShareLink"
    >
        <v-icon small>far fa-link</v-icon>
    </v-btn>
</template>

<script>
import apiClient from '../../api/apiClient';

export default {
    name: "ShareLinkButton",
    props: {
        shareLinkUrl: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        isGenerating: false,
    }),
    methods: {
        generateShareLink() {
            this.isGenerating = true;
            apiClient.get(this.shareLinkUrl)
                .then(response => this.copyToClipboard(response.data.url))
                .catch(() => this.$store.dispatch('showSnackbar', {
                    text: 'Generating of share link failed',
                    color: 'error',
                }))
                .finally(() => {
                    this.isGenerating = false;
                });
        },
        copyToClipboard(url) {
            navigator.clipboard.writeText(url)
                .then(() => this.$store.dispatch('showSnackbar', {
                    text: 'Share link succesfully copied to clipboard',
                }))
                .catch(() => this.$store.dispatch('showSnackbar', {
                    text: 'Copying share link to clipboard failed',
                    color: 'error',
                }));
        },
    },
}
</script>
